"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
require("./spinner.scss");
const Spinner = (props) => {
    const { className } = props;
    const classNames = (0, classnames_1.default)('spinner', className !== null && className !== void 0 ? className : '');
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--1' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--2' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--3' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--4' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--5' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--6' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--7' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--8' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--9' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--10' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--11' }),
        react_1.default.createElement("div", { className: 'spinner__bar spinner__bar--12' })));
};
exports.Spinner = Spinner;
//# sourceMappingURL=Spinner.js.map